// Lib
import React from 'react';
import EmojiPopupContent from '../../../components/emoji/popup/EmojiPopupContent';
import useReactionsPopupHooks from './useReactionsPopupHooks';
import { ReactionsPopupContentProps } from './reactionsPopupTypes';

const ReactionsPopupContent: React.FC<ReactionsPopupContentProps> = (props) => {
    const { gridSize, elementIds, closePopup } = props;

    const { selectedReactionIds, onSelectReaction } = useReactionsPopupHooks(elementIds);

    return (
        <EmojiPopupContent
            gridSize={gridSize}
            selectedEmojiIds={selectedReactionIds}
            onSelectEmoji={onSelectReaction}
            closePopup={closePopup}
        />
    );
};

export default ReactionsPopupContent;
